<template>
  <div class="global-fix-sidebar" v-if="siteConfig.isShowBar == 1 && isContact">
    <!-- QQ -->
    <div
      v-show="sidebarQQList.length > 0"
      class="global-fix-item"
      title="在线咨询"
      v-if="siteConfig.sidebarQQType != 5"
    >
      <div class="global-fix-title">
        <div class="global-fix-icon">
          <Icon custom="ich-icon ich-icon-qq" />
        </div>
        <span>咨询</span>
      </div>
      <div class="global-fix-body global-fix-qq">
        <a
          :href="item.url"
          v-for="(item, index) in sidebarQQList"
          :key="index"
          :target="item.type"
        >
          <div class="qq-list">
            <div class="qq-item-img">
              <img src="../../assets/images/v3/sider-contact.png" />
            </div>
            <div class="qq-item-info">
              QQ咨询{{ index + 1 }}
              <p>{{ item.qq }}</p>
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- 微信 -->
    <div
      v-show="sidebarQQList.length > 0"
      class="global-fix-item"
      title="在线咨询"
      v-if="siteConfig.sidebarQQType == 5"
    >
      <div class="global-fix-title">
        <div class="global-fix-icon">
          <Icon custom="ich-icon ich-icon-subscription" />
        </div>
        <span>咨询</span>
      </div>
      <div class="global-fix-body global-fix-qq">
        <a
          href="javascript:;"
          v-for="(item, index) in sidebarQQList"
          :key="index"
          @click="copywxFunc(item)"
        >
          <div class="qq-list">
            <div class="qq-item-img">
              <img src="../../assets/images/v3/sider-wechat.png" />
            </div>
            <div class="qq-item-info">
              微信咨询{{ index + 1 }}
              <p>{{ item.qq }}</p>
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- Tel -->
    <div
      v-show="siteConfig.sidebarTel"
      class="global-fix-item"
      title="客服电话"
    >
      <div class="global-fix-title">
        <div class="global-fix-icon">
          <Icon custom="ich-icon ich-icon-tel" />
        </div>
        <span>电话</span>
      </div>
      <div class="global-fix-body global-fix-tel">
        <div
          class="tel-list"
          v-if="this.siteConfig.adminMobile && isLogin && loginUser.ugid == 1"
        >
          <div class="tel-item-img">
            <img src="../../assets/images/v3/sider-contact-t.png" />
          </div>
          <div class="tel-item-info">
            招生老师
            <p>{{ this.siteConfig.adminMobile }}</p>
          </div>
        </div>
        <div class="tel-list" v-for="(item, index) in telList" :key="index">
          <div class="tel-item-img">
            <img src="../../assets/images/v3/sider-contact.png" />
          </div>
          <div class="tel-item-info">
            咨询电话{{ index + 1 }}
            <p>{{ item }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- wx qrcode -->
    <div
      v-show="siteConfig.sidebarQRCode"
      class="global-fix-item"
      title="公众号"
    >
      <div class="global-fix-title">
        <div class="global-fix-icon">
          <Icon custom="ich-icon ich-icon-wechat" />
        </div>
        <span>公众号</span>
      </div>
      <div class="global-fix-body global-fix-qrcode">
        <i>
          <img
            v-if="siteConfig.agencyId === 0"
            src="../../assets/images/wx-qrcode.jpg"
            alt="扫一扫"
          />
          <img
            v-else
            :src="concatImageUrl(siteConfig.sidebarQRCode)"
            alt="扫一扫"
          />
        </i>
      </div>
    </div>
    <!-- app qrcode -->
    <div
      v-show="siteConfig.isShowAppQrcode"
      class="global-fix-item"
      title="APP下载"
    >
      <div class="global-fix-title">
        <div class="global-fix-icon">
          <Icon custom="ich-icon ich-icon-phone-dot" />
        </div>
        <span>APP下载</span>
      </div>
      <div class="global-fix-body global-fix-qrcode">
        <i>
          <template v-if="!isCustomApp">
            <img src="../../assets/images/app-qrcode(1).jpg" alt="qrcode" />
          </template>
          <template v-else>
            <vue-qr
              :margin="5"
              :size="560"
              :correctLevel="3"
              :text="appQrcodeData.url"
              :logoSrc="appQrcodeData.icon"
              :logoMargin="5"
              style="display: block"
            ></vue-qr>
          </template>
        </i>
      </div>
    </div>
    <!-- 小程序 -->
    <div class="global-fix-item" title="小程序" v-show="false">
      <div class="global-fix-title">
        <div class="global-fix-icon">
          <Icon custom="ich-icon ich-icon-wecode" />
        </div>
        <span>小程序</span>
      </div>
      <div class="global-fix-body global-fix-qrcode">
        <i>
          <template v-if="!isCustomApp">
            <img src="../../assets/images/app-qrcode.png" alt="qrcode" />
          </template>
          <template v-else>
            <vue-qr
              :margin="5"
              :size="180"
              :correctLevel="3"
              :text="appQrcodeData.url"
              :logoSrc="appQrcodeData.icon"
              :logoMargin="5"
              style="display: block"
            ></vue-qr>
            <!-- <vue-qr
              :margin="5"
              :size="180"
              :correctLevel="3"
              :text="appQrcodeData.url"
              :logoMargin="5"
              style="display: block"
            ></vue-qr> -->
          </template>
        </i>
      </div>
    </div>
    <div
      class="global-fix-item global-fix-gotop"
      :class="{ showTop: scrollTopVisible }"
      title="置顶"
      @click="gotoTop"
    >
      <div class="global-fix-title">
        <div class="global-fix-icon">
          <Icon custom="ich-icon ich-icon-top" />
        </div>
        <span>置顶</span>
      </div>
    </div>
    <iframe
      name="qiyeqq"
      frameborder="0"
      src="about:blank"
      style="width: 0; height: 0; display: none"
    ></iframe>
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import { addJs } from '../../utils/utils';
import VueQr from 'vue-qr';
export default {
  mixins: [siteMixin],
  data() {
    return {
      scrollTopVisible: false,
      appQrcodeData: {
        url: '',
        icon: '',
      },
      isCustomApp: false,
      isContact:true
    };
  },
  computed: {
    sidebarQQList() {
      if (
        this.siteConfig.sidebarQQType != 1 &&
        this.siteConfig.sidebarQQType != 2 &&
        this.siteConfig.sidebarQQType != 5
      ) {
        return [];
      }
      if (!this.siteConfig.sidebarQQ) return [];
      let list = [];
      const personQQ = process.env.VUE_APP_PERSON_QQ;
      const companyQQ = process.env.VUE_APP_COMPANY_QQ;
      this.siteConfig.sidebarQQ.split(',').forEach((item, index) => {
        let url = personQQ.replace('{0}', item);
        let type = '_blank';
        if (this.siteConfig.sidebarQQType === 2) {
          url = companyQQ.replace('{0}', item);
          type = 'qiyeqq';
        }
        list.push({
          type,
          qq: item,
          url,
        });
      });
      return list;
    },
    telList() {
      if (!this.siteConfig.sidebarTel) return [];
      return this.siteConfig.sidebarTel.split(',');
    },
  },
  mounted() {
    // 当前agencyId为0  并且域名不是本公司其下域名，则隐藏
    const hostname = window.location.hostname;
    if (this.siteConfig.agencyId === 0 && hostname !== process.env.VUE_APP_WEB_DOMAIN ) {
      this.isContact = false
    }

    this.showOrHideScrollTop();
    this.setQrCode();
    this.setFooterJs();
  },
  methods: {
    setQrCode() {
      if (this.siteConfig.agencyId <= 0) return;
      this.isCustomApp = true;
      this.appQrcodeData = {
        url: window.location.protocol + '//' + document.domain + '/app',
        icon: this.concatImageUrl(this.siteConfig?.qrCodeLogo),
      };
    },
    setFooterJs() {
      //初始化底部脚本信息
      const lead = 'http://lead.soperson.com/{0}.js';
      const baidu = 'https://hm.baidu.com/hm.js?{0}';
      if (this.siteConfig.sidebarQQ) {
        if (this.siteConfig.sidebarQQType == 3) {
          addJs(lead.replace('{0}', this.siteConfig.sidebarQQ));
        }
        if (this.siteConfig.sidebarQQType == 4) {
          addJs(baidu.replace('{0}', this.siteConfig.sidebarQQ));
        }
      }
      const cnzz = 'https://s11.cnzz.com/z_stat.php?id={0}&web_id={0}';
      if (this.siteConfig.agencyId == 0) {
        addJs(
          'https://s11.cnzz.com/z_stat.php?id=1261806431&web_id=1261806431'
        );
      } else if (this.siteConfig.cnzzStatisKey) {
        const url = cnzz.replace(/\{0\}/g, this.siteConfig.cnzzStatisKey);
        addJs(url);
      }
    },
    showOrHideScrollTop() {
      window.addEventListener('scroll', () => {
        const scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (scrollTop > 200) {
          this.scrollTopVisible = true;
        } else {
          this.scrollTopVisible = false;
        }
      });
    },
    gotoTop() {
      window.scroll({ top: top, left: 0, behavior: 'smooth' });
    },
    copywxFunc(item) {
      var _input = document.createElement('input');
      _input.value = item.qq; // 设置内容
      document.body.appendChild(_input); // 添加临时实例
      _input.select(); // 选择实例内容
      document.execCommand('Copy'); // 执行复制
      this.$message.success('复制成功');
      document.body.removeChild(_input); // 删除临时实例
    },
  },
  components: {
    VueQr,
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';
.global-fix-sidebar {
  position: fixed;
  width: 60px;
  right: 15px;
  bottom: 50px;
  z-index: 500;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  // border-radius: 6px;
  // padding: 5px 0;
  .global-fix-item {
    position: relative;
    width: 100%;
    height: 60px;
    color: #333;
    cursor: pointer;
    .transTime(0.2s);
    &:hover {
      color: #fff;
      .background-primary();
      .global-fix-body {
        visibility: visible;
        opacity: 1;
      }
    }
    .global-fix-title {
      width: 100%;
      height: 100%;
      padding-top: 5px;
      text-align: center;
      .global-fix-icon {
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 24px;
      }
      span {
        height: 20px;
        font-size: 12px;
        display: block;
      }
    }
    .global-fix-body {
      visibility: hidden;
      opacity: 0;
      .transTime(0.5s);
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      &:before {
        position: absolute;
        content: ' ';
        border: 8px solid transparent;
        border-left: 8px solid #fff;
        bottom: 22px;
        right: -16px;
        z-index: 2;
      }
      &.global-fix-qq {
        position: absolute;
        background-color: #fff;
        right: 70px;
        bottom: 0;
        line-height: 30px;
        font-size: 16px;
        white-space: nowrap;
        min-height: 60px;
        .qq-list {
          display: flex;
          padding: 5px;
          .qq-item-img {
            width: 50px;
            height: 50px;
            padding: 5px;
            margin-right: 5px;
            img {
              width: 40px;
              height: 40px;
            }
          }
          .qq-item-info {
            color: #333;
            font-size: 12px;
            line-height: 25px;
            p {
              font-size: 16px;
            }
            padding-right: 10px;
          }
        }
      }
      &.global-fix-tel {
        position: absolute;
        background-color: #fff;
        right: 70px;
        bottom: 0;
        /*height: 63px;*/
        line-height: 30px;
        font-size: 16px;
        white-space: nowrap;
        min-height: 60px;
        .tel-list {
          display: flex;
          padding: 5px;
          .tel-item-img {
            width: 50px;
            height: 50px;
            padding: 5px;
            margin-right: 5px;
            img {
              width: 40px;
              height: 40px;
            }
          }
          .tel-item-info {
            color: #333;
            font-size: 12px;
            line-height: 25px;
            p {
              font-size: 16px;
            }
            padding-right: 10px;
          }
        }
      }
      &.global-fix-qrcode {
        position: absolute;
        right: 70px;
        bottom: 0;
        i {
          display: block;
          background-color: #fff;
          // border: 2px solid #0084ff;
          // border-radius: 6px;
          overflow: hidden;
          padding: 2px;
        }
        img {
          width: 150px;
          height: 150px;
        }
      }
    }
    &.global-fix-gotop {
      height: 0;
      padding: 0;
      transition: all 0.2s linear;
      overflow: hidden;
      &.showTop {
        // padding: 10px 0;
        height: 60px;
      }
    }
  }
}
</style>
